<template>
  <div class="bienvenida-page">
          <div class="rasgado rasgado-superior"></div>

    <p class="versiculo-referencia-fija" ref="versiculoRef"></p>

    <!-- Contenedor fecha -->
    <div class="fecha-evento" ref="fechaRef"><br><br><br><br>
      <p class="titulo-mis-quince opacity-zero" ref="granDiaRef">Save the Date</p>
      <div class="fecha-bloque-central">
        <p class="fecha-dia-semana opacity-zero" ref="diaSemanaRef">Sábado</p>
        <p class="fecha-dia-numero opacity-zero" ref="numeroRef">28</p>
        <p class="fecha-mes opacity-zero" ref="mesRef">NOVIEMBRE</p>
      </div>
      <p class="fecha-anio opacity-zero" ref="anioRef">2026</p><br><br>
<p class="subtitulo-save-date opacity-zero" ref="saveDateRef">
  Mis <span class="great-vibes">X</span>V’s
</p>    </div>

    <!-- Contenido principal -->
    <div class="bienvenida-container">
      <div class="contenido-bienvenida">
        <div class="mensaje-bienvenida opacity-zero" ref="mensajeRef">
          {{ mensaje }}
        </div>
        <div class="versiculo-container opacity-zero" ref="versiculoTextRef">
          <div class="tarjeta-editorial-wrapper">
            
            <p class="versiculo-texto-poetico">
              
Con el corazón lleno de gratitud, celebro esta nueva etapa de mi vida, poniendo mis sueños y mi futuro en las manos de Dios, confiando en que seguirá guiando cada uno de mis pasos.      
<br><br>
Gracias a Dios por darme unos padres maravillosos, una familia que me apoya y la alegría de festejar mis quince años con ustedes. 
Gracias por los sueños que apenas comienzan…
 </p>
            <div class="divisor-adorno">
              <span class="linea-adorno"></span>
              <span class="diamante-dorado">✨</span>
              <span class="linea-adorno"></span>
            </div>

         

            <p class="nota-presencia">
              Será un honor inolvidable compartir esta noche contigo.
            </p>

          </div>
        </div>
      </div>
    </div>

    <!-- Estrellas Decorativas en las Orillas -->
    <div class="estrella-orilla estrella-izq-1 render-gpu opacity-zero" ref="star1Ref">
      <svg viewBox="0 0 24 24" fill="currentColor" class="star-svg">
        <path d="M12 0L14.59 9.41L24 12L14.59 14.59L12 24L9.41 14.59L0 12L9.41 9.41L12 0Z"/>
      </svg>
    </div>

    <div class="estrella-orilla estrella-der-1 render-gpu opacity-zero" ref="star2Ref">
      <svg viewBox="0 0 24 24" fill="currentColor" class="star-svg">
        <path d="M12 0L14.59 9.41L24 12L14.59 14.59L12 24L9.41 14.59L0 12L9.41 9.41L12 0Z"/>
      </svg>
    </div>

    <div class="estrella-orilla estrella-izq-2 render-gpu opacity-zero" ref="star3Ref">
      <svg viewBox="0 0 24 24" fill="currentColor" class="star-svg">
        <path d="M12 0L14.59 9.41L24 12L14.59 14.59L12 24L9.41 14.59L0 12L9.41 9.41L12 0Z"/>
      </svg>
    </div>

    <!-- Grupos decorativos -->
    <div class="disco-group disco1-group" ref="group1Ref">
      <img src="@/assets/rama.png" alt="rama" class="rama-decorativa render-gpu opacity-zero" ref="rama1Ref" />
      <img src="@/assets/monio.png" alt="disco" class="disco render-gpu opacity-zero" ref="disco1Ref" />
    </div>

    <div class="disco-group disco2-group" ref="group2Ref">
      <img src="@/assets/rama.png" alt="rama" class="rama-decorativa render-gpu opacity-zero" ref="rama2Ref" />
      <img src="@/assets/monio.png" alt="disco" class="disco render-gpu opacity-zero" ref="disco2Ref" />
    </div>

    <div class="disco-group disco3-group" ref="group3Ref">
      <img src="@/assets/mari.png" alt="disco" class="disco render-gpu opacity-zero" ref="disco3Ref" />
    </div>
  </div>
</template>

<script>
import { ref, onMounted, onUnmounted, nextTick } from 'vue';
import { gsap } from 'gsap';

export default {
  name: 'BienvenidaPage',
  setup() {
    const mensaje = ref('');
    const fechaRef = ref(null);
    const mensajeRef = ref(null);
    const versiculoTextRef = ref(null);
    const versiculoRef = ref(null);

    const granDiaRef = ref(null);
    const diaSemanaRef = ref(null);
    const numeroRef = ref(null);
    const mesRef = ref(null);
    const anioRef = ref(null);
    const saveDateRef = ref(null);

    const group1Ref = ref(null);
    const group2Ref = ref(null);
    const group3Ref = ref(null);

    const disco1Ref = ref(null);
    const disco2Ref = ref(null);
    const disco3Ref = ref(null);
    const rama1Ref = ref(null);
    const rama2Ref = ref(null);

    const star1Ref = ref(null);
    const star2Ref = ref(null);
    const star3Ref = ref(null);

    let observer = null;

    const setupObserver = () => {
      gsap.config({ force3D: true });

      const options = {
        threshold: 0.15,
        rootMargin: '0px 0px -40px 0px'
      };

      const animarFecha = () => {
        const tl = gsap.timeline({ defaults: { ease: 'power2.out', force3D: true } });
        tl.fromTo(granDiaRef.value, 
          { autoAlpha: 0, y: 15, scale: 0.95 }, 
          { autoAlpha: 1, y: 0, scale: 1, duration: 0.9 }
        )
        .fromTo(numeroRef.value, 
          { autoAlpha: 0, scale: 0.7, y: 10 }, 
          { autoAlpha: 1, scale: 1, y: 0, duration: 0.9, ease: 'back.out(1.3)' }, 
          '-=0.5'
        )
        .fromTo([diaSemanaRef.value, mesRef.value, anioRef.value], 
          { autoAlpha: 0, y: 10 }, 
          { autoAlpha: 1, y: 0, duration: 0.5, stagger: 0.1 }, 
          '-=0.6'
        )
        .fromTo(saveDateRef.value,
          { autoAlpha: 0, y: 10 },
          { autoAlpha: 1, y: 0, duration: 0.7 },
          '-=0.3'
        );
      };

      const animarComboMagico = (discoEl, ramaEl) => {
        const tl = gsap.timeline({ defaults: { force3D: true } });
        if (ramaEl) {
          tl.fromTo(ramaEl, 
            { autoAlpha: 0, scale: 0.6, rotate: -12, transformOrigin: 'bottom center' }, 
            { autoAlpha: 1, scale: 1, rotate: 0, duration: 1.1, ease: 'power3.out' }
          );
        }
        tl.fromTo(discoEl, 
          { autoAlpha: 0, scale: 0.5, rotate: 20 }, 
          { autoAlpha: 1, scale: 1, rotate: 0, duration: 0.9, ease: 'back.out(1.2)' }, 
          ramaEl ? '-=0.8' : 0
        );
      };

      const animarTexto = (el) => {
        gsap.fromTo(el, 
          { autoAlpha: 0, y: 25 }, 
          { autoAlpha: 1, y: 0, duration: 1.0, ease: 'power3.out', force3D: true }
        );
      };

      const animarEstrellas = () => {
        const estrellas = [star1Ref.value, star2Ref.value, star3Ref.value];
        gsap.fromTo(estrellas, 
          { autoAlpha: 0, scale: 0, rotate: -45 }, 
          { 
            autoAlpha: 1, 
            scale: 1, 
            rotate: 0, 
            duration: 1.2, 
            stagger: 0.2, 
            ease: 'back.out(1.7)',
            onComplete: () => {
              gsap.to(estrellas, {
                scale: 1.25,
                opacity: 0.85,
                duration: 1.6,
                repeat: -1,
                yoyo: true,
                ease: 'sine.inOut',
                stagger: 0.3
              });
            }
          }
        );
      };

      const targetsMap = new Map();
      if (fechaRef.value) targetsMap.set(fechaRef.value, animarFecha);
      if (mensajeRef.value) targetsMap.set(mensajeRef.value, () => animarTexto(mensajeRef.value));
      if (versiculoTextRef.value) {
        targetsMap.set(versiculoTextRef.value, () => {
          animarTexto(versiculoTextRef.value);
          animarEstrellas();
        });
      }
      
      if (group1Ref.value) targetsMap.set(group1Ref.value, () => animarComboMagico(disco1Ref.value, rama1Ref.value));
      if (group2Ref.value) targetsMap.set(group2Ref.value, () => animarComboMagico(disco2Ref.value, rama2Ref.value));
      if (group3Ref.value) targetsMap.set(group3Ref.value, () => animarComboMagico(disco3Ref.value, null));

      observer = new IntersectionObserver((entries) => {
        entries.forEach((entry) => {
          if (entry.isIntersecting) {
            const animFn = targetsMap.get(entry.target);
            if (animFn) {
              animFn();
              observer.unobserve(entry.target);
            }
          }
        });
      }, options);

      targetsMap.forEach((_, el) => observer.observe(el));
    };

    onMounted(async () => {
      await nextTick();
      setupObserver();
    });

    onUnmounted(() => {
      if (observer) observer.disconnect();
    });

    return {
      mensaje, fechaRef, mensajeRef, versiculoTextRef, versiculoRef,
      granDiaRef, diaSemanaRef, numeroRef, mesRef, anioRef, saveDateRef,
      group1Ref, group2Ref, group3Ref,
      disco1Ref, disco2Ref, disco3Ref, rama1Ref, rama2Ref,
      star1Ref, star2Ref, star3Ref
    };
  }
};
</script>

<style scoped>
@import url('https://fonts.googleapis.com/css2?family=Cinzel:wght@400;500;600&family=Cormorant+Garamond:ital,wght@0,300;0,400;0,500;1,400&family=Pinyon+Script&family=Playfair+Display:ital,wght@0,400;1,400&family=Poppins:ital,wght@0,300;1,300&display=swap');

/* Estructura Base */
.bienvenida-page {
  position: relative;
  background: transparent;
  color: black;
  min-height: 100vh;
  padding: 0px 20px;
  margin-top: 0px;
  margin-bottom: 55px;
  box-sizing: border-box;
  text-align: center;
  overflow: hidden;
}

/* Fecha y Títulos con Estilo Degradado */
.fecha-evento {
  text-align: center;
  margin: 10px 0 25px;
  position: relative;
  z-index: 5;
}

.titulo-mis-quince { 
  font-family: 'CynthiaJuneJF', 'Pinyon Script', cursive !important; 
  font-size: 57px !important; 
  line-height: 1.1;
  padding-bottom: 2px;
}

.subtitulo-save-date {
  font-family: "Great Vibes", cursive;
  font-size: 42px !important;
  line-height: 1.5;
  margin-top: 8px;
  font-weight: 200;
}

.titulo-mis-quince, .subtitulo-save-date, .fecha-dia-semana, .fecha-dia-numero, .fecha-mes, .fecha-anio {
  background: linear-gradient(110deg, #e6a6c6 30%, #ff85ae 45%, #faadd8 50%, #ff85c2 55%, #ef90ae 70%);
  background-size: 200% auto;
  -webkit-background-clip: text;
  background-clip: text;
  color: transparent;
  -webkit-text-fill-color: transparent;
  filter: drop-shadow(0px 1px 2px rgba(0,0,0,0.25));
  display: block;
  margin: 0 auto;
}

.fecha-dia-semana { font-family: 'fecha', 'Cinzel', serif; font-size: 28px; margin: 5px 0; }
.fecha-dia-numero { font-family: 'fecha', 'Cormorant Garamond', serif; font-size: 74px !important; font-weight: bold; }
.fecha-mes { font-family: 'Playfair Display', serif; font-size: 26px; font-weight: 600; letter-spacing: 3px; }
.fecha-anio { font-family: 'Poppins', sans-serif; font-size: 16px; font-style: italic; }

/* Contenedor Limpio (Sin Marco / Sin Fondo Rosa) */
.bienvenida-container { 
  display: flex; 
  flex-direction: column; 
  align-items: center; 
  position: relative;
  z-index: 4;
}

.tarjeta-editorial-wrapper {
  background: transparent;
  border: none;
  box-shadow: none;
  padding: 10px 15px;
  margin: 0 auto;
  max-width: 350px;
}

.versiculo-container { 
  margin: 0 auto; 
  text-align: center; 
}

/* Tipografía de Texto Ampliada */
.versiculo-texto-poetico { 
  font: 17px 'quote', sans-serif;
  line-height: 1.8;
  color: #333;
    margin-left: 0 !important;
  margin-right: 0 !important;
  margin: 0;
}

.versiculo-texto-destacado {
  font-family: 'Cormorant Garamond', serif;
  font-size: 20px;
  line-height: 1.7;
  color: #2b2b2b;
  font-style: italic;
  text-align: center;
  margin: 0;
}

.nota-presencia {
  font-family: 'CynthiaJuneJF', 'Pinyon Script', cursive;
  font-size: 39px;
  color: #e4a3c2;
  margin-top: 20px;
  margin-bottom: 0;
  line-height: 1.2;
  filter: drop-shadow(0px 1px 1px rgba(0,0,0,0.15));
}

/* Divisor Decorativo */
.divisor-adorno {
  display: flex;
  align-items: center;
  justify-content: center;
  gap: 12px;
  margin: 20px 0;
}

.linea-adorno {
  height: 1px;
  width: 55px;
  background: linear-gradient(90deg, transparent, rgba(250, 173, 216, 0.8), transparent);
}

.diamante-dorado {
  font-size: 11px;
  color: #ff85ae;
}

/* Estrellas Mágicas en Orillas */
.estrella-orilla {
  position: absolute;
  width: 20px;
  height: 20px;
  color: #ff85c2;
  filter: drop-shadow(0px 0px 8px rgba(255, 133, 194, 0.9));
  pointer-events: none;
  z-index: 5;
}

.star-svg {
  width: 100%;
  height: 100%;
}

.estrella-izq-1 { top: 36%; left: 8px; width: 22px; height: 22px; }
.estrella-der-1 { top: 52%; right: 10px; width: 20px; height: 20px; color: #faadd8; }
.estrella-izq-2 { top: 68%; left: 12px; width: 18px; height: 18px; color: #ef90ae; }

/* Decoraciones Visuales */
.disco-group {
  position: absolute;
  pointer-events: none;
  z-index: 2;
  display: flex;
  align-items: center;
  justify-content: center;
}

.disco {
  width: 120px;
  height: auto;
  position: relative;
  z-index: 2;
}
.great-vibes {
  font-family: "Great Vibes", cursive;
  padding-bottom: 5px;
}
.rama-decorativa {
  position: absolute;
  width: 240px;
  height: auto;
  margin-top: 100px;
  z-index: 1;
  opacity: 0;
  filter: brightness(1.1);
}

/* Posiciones */
.disco1-group { top: 3%; right: -10%; width: 150px !important; z-index: 10 !important; }
.disco2-group { top: 3%; left: -5%; width: 120px; }
.disco3-group { bottom: -5%; left: -22%; z-index: 10; width: 150px !important; }

/* Optimización GPU */
.render-gpu {
  will-change: transform, opacity;
  transform: translate3d(0, 0, 0);
  backface-visibility: hidden;
}

.opacity-zero {
  opacity: 0;
}
.rasgado{
  position:absolute;
  left:0;
  width:100%;
  height:50px;
  background:#f0c9d3;
  z-index:3;
  margin-top:0px;
  pointer-events:none;
}

.rasgado-superior{
  top:0;
  clip-path: polygon(
    0% 80%, 25% 60%, 50% 85%, 75% 55%, 100% 75%,
    100% 0%, 0% 0%
  );
}
</style>